import React from 'react';
import { RouteObject } from 'react-router-dom';
import { lazily } from '../utils/lazily';
import { EditBikeDetails } from '../features/cases/components/EditBikeDetails';

// Lazy-loaded page components for better code splitting and performance
const {
  CaseManagementPage,
  CaseDetailPage,
  CaseHistoryPage,
  DocumentGalleryPage,
  BikeInventoryPage,
  ClientDataPage,
  FinancialSummaryPage
} = lazily(() => import('../pages'));

// Layout component
const { MainLayout } = lazily(() => import('../layouts/MainLayout'));

// Special redirect component
const { ForceClientDataRedirect } = lazily(() => import('../components/features/ForceClientDataRedirect'));

/**
 * All application routes defined in one place
 * This makes it easier to manage and understand the app's navigation structure
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      // Home route, redirects to case management
      { 
        index: true,
        element: <CaseManagementPage /> 
      },

      // Case management routes
      { 
        path: 'case-management',
        children: [
          { index: true, element: <CaseManagementPage /> },
          { path: ':id', element: <CaseDetailPage /> },
          { path: ':id/documents', element: <DocumentGalleryPage /> }
        ]
      },

      // Legacy case routes (kept for backward compatibility)
      { 
        path: 'cases', 
        children: [
          { index: true, element: <CaseManagementPage /> },
          { path: ':id', element: <CaseDetailPage /> },
          { path: ':id/documents', element: <DocumentGalleryPage /> }
        ]
      },

      // Case history routes
      { 
        path: 'case-history', 
        element: <CaseHistoryPage /> 
      },
      // Legacy history route
      { 
        path: 'history', 
        element: <CaseHistoryPage /> 
      },

      // Client data routes
      { 
        path: 'client-data/:id', 
        element: <ClientDataPage /> 
      },
      
      // Special client data redirect route
      { 
        path: 'redirect-to-client-data/:id', 
        element: <ForceClientDataRedirect /> 
      },

      // Bike management routes
      { 
        path: 'bike-management', 
        element: <BikeInventoryPage /> 
      },
      // Legacy bikes route
      { 
        path: 'bikes', 
        element: <BikeInventoryPage /> 
      },
      {
        path: 'bikes/:bikeId',
        element: <EditBikeDetails />
      },

      // Financial summary routes
      { 
        path: 'financial-summary', 
        element: <FinancialSummaryPage /> 
      }
    ]
  }
];
